import React from "react";
import { hydrateRoot } from "react-dom/client";
import { loadableReady } from "@loadable/component";
import { createDateLocaleLoader } from "../../utils/dateLocaleLoader.js";
import { setupRemoteComponentContext } from "./remoteComponentSetup.js";
import { createHandleClientRenderingError, createOnHydrationError } from "./errors.js";
import { createStore } from "../../store/index.js";
import ClientProviders from "./ClientProviders.js";
export async function createClientApp(config) {
    const { rootNode, appComponent, prefix = "", globalContext, i18nState, enableRemoteComponents = true, onClientRenderingError, onHydrationError } = config;
    const handleError = onClientRenderingError ?? createHandleClientRenderingError(globalContext);
    const handleHydrationError = onHydrationError ?? createOnHydrationError(globalContext);
    try {
        await loadableReady();
        const dateLocaleLoader = createDateLocaleLoader(i18nState.locale);
        const dateLocale = await dateLocaleLoader();
        if (!dateLocale) {
            throw new Error("Locales should either be imported from date-fns or follow its pattern");
        }
        let rcContext;
        if (enableRemoteComponents) {
            rcContext = await setupRemoteComponentContext(globalContext);
        }
        const store = createStore();
        const root = hydrateRoot(rootNode, React.createElement(ClientProviders, { appComponent: appComponent, prefix: prefix, globalContext: globalContext, i18nState: i18nState, store: store, rcContext: rcContext, dateLocale: dateLocale }), {
            onRecoverableError: handleHydrationError
        });
        return { root };
    }
    catch (e) {
        handleError(e);
        throw e;
    }
}
